<template>
	<div class="graph">
        <ScaleTabs
			v-bind:scale="scale"
			:scales="scales"
			@change="setScale"></ScaleTabs>
        <DatePicker
			v-bind:date="date"
			v-bind:startDate="startDate"
			@previous="previous"
			@next="next"></DatePicker>
		<WaterGraph1D
			v-bind:data="waterData"
			v-bind:startDate="startDate"
			v-bind:date="date"
			v-bind:interval="interval"
			v-bind:binWidth="binWidth">
		</WaterGraph1D>
	</div>
</template>

<script>
import Graph from './index'

export default {
	name: 'water-graph',
	extends: Graph,

	computed: {
		/**
		 * @function 	waterData
		 * @desc		Returns the water data with time and number of glasses
		 */
		waterData() {
			return this.data.map((water) => {
				let point

				// Adding time
				if (water.date_time)
					point = { time: water.date_time }
				else
					point = { time: water.created }

				// Adding quantity
				if(water.amount && water.amount.value && water.amount.unit)
					point.amount = water.amount

				return point
			})
		}
	}
}
</script>
